import { mdiCheck, mdiInformationOutline, mdiMinus } from '@mdi/js'

export const SUBSCRIPTION_UPDATE_ROUTE = 'update'
export const SUBSCRIPTION_MANAGE_ROUTE = 'manage'
export const SUBSCRIPTION_RENEWALS_ROUTE = 'renewals'
export const SUBSCRIPTION_DETAILS_ROUTE = 'details'
export const SUBS_MANAGE_ADD_CARD_ROUTE = 'add-card'
export const SUBS_MANAGE_UPGRADE_ROUTE = 'upgrade'
export const SUBS_MANAGE_SUCCESS_ROUTE = 'checkout-success'

export const SETUP_INTENT_REDUCER_NAME = 'setupIntent'
export const INVOICE_REDUCER_NAME = 'invoice'

export const PlansTableIcons = {
  checkmark: mdiCheck,
  info: mdiInformationOutline,
  minus: mdiMinus,
}

export type PlansTableElement =
  | keyof typeof PlansTableIcons
  | 'unlimited'
  | 'video'
